/* Settings.
 *
 * WHO YOU ARE MOVED BACK TO PROFILE on 2026-09-17, with the fifth tab. What was
 * thin about Profile was the parts that were false, not the screen.
 *
 * FROM THE ARTBOARD'S SETTINGS, ALSO NOT HERE: the language switch, because
 * Arabic ships after a native speaker has read it; notification toggles, because
 * there is no channel to switch on or off and a toggle that sends nothing is a
 * control that lies; and a recovery phrase and authenticator two-step, because
 * the product has a passkey instead. "Download your data" and "Delete your
 * account" are both here, and both are real.
 *
 * A VALUE ON EVERY ROW, NOT A CHEVRON ALONE. A list where every row says the
 * same thing on the right tells you nothing without opening it.
 */
import { t } from "@damga/kit";

import { Icon, phoneForDisplay } from "../ui";

export interface SettingsProps {
  name: string | null;
  phone: string;
  email: string | null;
  emailVerified: boolean;
  hasPasskey: boolean;
  canPasskey: boolean;
  onEditName: () => void;
  onEditEmail: () => void;
  onUsePasskey: () => void;
  onWhoSees: () => void;
  onExport: () => void;
  onErase: () => void;
  onSignOut: () => void;
}

function Row({
  title,
  body,
  end,
  onClick,
  danger = false,
  warn = false,
}: {
  title: string;
  body: string;
  end?: string;
  onClick?: () => void;
  danger?: boolean;
  warn?: boolean;
}) {
  return (
    <button type="button" className="group-row" onClick={onClick} disabled={!onClick}>
      <span className="shrink">
        <span className="group-row-title" data-danger={danger ? "" : undefined}>
          {title}
        </span>
        <span className="group-row-body" data-warn={warn ? "" : undefined}>
          {body}
        </span>
      </span>
      {onClick && (
        <span className="group-row-end">
          {end}
          <Icon name="chevronRight" size={15} />
        </span>
      )}
    </button>
  );
}

export function Settings(p: SettingsProps) {
  return (
    <>
      <section className="group" aria-labelledby="set-security">
        <h2 className="label" id="set-security">
          {t("settings.security")}
        </h2>
        <Row
          title={t("settings.name")}
          body={p.name ?? t("settings.notSet")}
          end={p.name ? t("settings.change") : t("settings.add")}
          onClick={p.onEditName}
        />
        {/* Not editable, and shown because it is what the cards hang off. */}
        {p.phone && <Row title={t("settings.phone")} body={phoneForDisplay(p.phone)} />}
        <Row
          title={t("settings.email")}
          body={p.email ? (p.emailVerified ? p.email : `${p.email} · ${t("settings.emailUnverified")}`) : t("settings.notSet")}
          end={p.email ? t("settings.change") : t("settings.add")}
          onClick={p.onEditEmail}
          warn={!p.email}
        />
        {/* Only where the device can make one. */}
        {p.canPasskey && (
          <Row
            title={t("settings.faceId")}
            body={p.hasPasskey ? t("settings.on") : t("settings.off")}
            end={p.hasPasskey ? undefined : t("settings.setUp")}
            onClick={p.hasPasskey ? undefined : p.onUsePasskey}
          />
        )}
      </section>

      <section className="group" aria-labelledby="set-data">
        <h2 className="label" id="set-data">
          {t("settings.yourData")}
        </h2>
        <Row title={t("settings.whoSees")} body={t("settings.whoSeesBody")} onClick={p.onWhoSees} />
        <Row title={t("settings.export")} body={t("settings.exportBody")} onClick={p.onExport} />
        <Row title={t("settings.delete")} body={t("settings.deleteBody")} onClick={p.onErase} danger />
      </section>

      <button type="button" className="btn btn-secondary" onClick={p.onSignOut}>
        <Icon name="signOut" size={16} />
        {t("settings.signOut")}
      </button>
    </>
  );
}
